import React, { ReactNode } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

interface IconBoxProps extends FlexProps {
  children?: ReactNode;
}

export default function IconBox(props: IconBoxProps) {
  const { children, ...rest } = props;

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"center"}
      borderRadius={"12px"}
      {...rest}
    >
      {children}
    </Flex>
  );
}

